import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconProgress25: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="progress-25, ideas, open, status, task" maskId="round-filled-radius-0-stroke-1.5-IconProgress25"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 12H19.5C19.5 7.85786 16.1421 4.5 12 4.5V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconProgress25;
